module.exports = __webpack_public_path__ + "img/12.71bdd6ed.png";